import styles from './floating-action-button.module.scss';
import MaterialFab from '@mui/material/Fab';

/* eslint-disable-next-line */
export interface FloatingActionButtonProps {
  children: any,
  // classes?: object,
  color?: 'default' | 'inherit' | 'primary' | 'secondary',
  // component?: any,
  disabled?: boolean,
  // disableFocusRipple?: boolean,
  // disableRipple?: boolean,
  href?: string,
  size?: 'small' | 'medium' | 'large',
  sx?: any,
  onClick?: (...args: any[]) => void,
  variant?: 'circular' | 'extended',
  className?: string,
  ['data-testid']?: string
}

export function Fab(props: FloatingActionButtonProps) {
  return (
    <MaterialFab
      onClick={props.onClick}
      color={props.color}
      variant={props.variant}
      disabled={props.disabled}
      size={props.size}
      href={props.href}
      sx={props.sx}
      data-testid={props['data-testid']}>
      {props.children}
    </MaterialFab>
  );
}

export function PrimaryFab(props: FloatingActionButtonProps) {
  return (
    <Fab {...props}
      className={props.className}
      color="primary"
      sx={props.sx}
    />
  );
}

export function SecondaryFab(props: FloatingActionButtonProps) {
  return (
    <Fab {...props}
      className={props.className}
      color="secondary"
      sx={props.sx}
    />
  );
}

export default Fab;